module.exports = __webpack_public_path__ + "img/top.0a36119e.png";